import {
  RAPPORT_CREER_ECHEC,
  RAPPORT_CREER_REQUETTE,
  RAPPORT_CREER_SUCCES,
  RAPPORT_LISTE_ECHEC,
  RAPPORT_LISTE_REQUETTE,
  RAPPORT_LISTE_SUCCES,
  RAPPORT_LISTE_RESET,
} from "../constantes/rapportConstantes";

export const listeRapportsReducer = (state = { rapports: [] }, action) => {
  switch (action.type) {
    case RAPPORT_LISTE_REQUETTE:
      return { loading: true };
    case RAPPORT_LISTE_SUCCES:
      return { loading: false, rapports: action.payload };
    case RAPPORT_LISTE_ECHEC:
      return { loading: false, erreur: action.payload };
    case RAPPORT_LISTE_RESET:
      return { loading: false, rapports: [] };
    default:
      return state;
  }
};

export const rapportCreerReducer = (state = { rapport: {} }, action) => {
  switch (action.type) {
    case RAPPORT_CREER_REQUETTE:
      return { loading: true };
    case RAPPORT_CREER_SUCCES:
      return { loading: false, rapport: action.payload };
    case RAPPORT_CREER_ECHEC:
      return { loading: false, erreur: action.payload };

    default:
      return state;
  }
};
